module.exports = __webpack_public_path__ + "static/media/50d.2913a34e.png";